import {
    type TypedUseSelectorHook,
    useDispatch,
    useSelector,
} from "react-redux";
import { type AnyAction } from "redux";
import { type ThunkDispatch } from "redux-thunk";
import { type RootState } from "../Reducers/DeveloperReducers";
import { type store } from "./RoutingAndStore";

export type DeveloperDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export const useDeveloperDispatch: () => DeveloperDispatch = useDispatch<typeof store.dispatch>;
export const useDeveloperSelector: TypedUseSelectorHook<RootState> = useSelector;
